import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PostRequestCached } from "../generics/helper";

const VehicleBrandAutoComplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], disabled = false, isFormikFormField = false, onlyVehicleMappedOems = false, showFormError = false, onlyVehicleLoginBranchMappedOems=false, ...rest } = props;
    // let userRoleOptions = allOption ? [{roleTitle:'All Roles',vehicleOemId:0}] : [];
    let vehicleBrandOption = [];
    if (allOption) {
        vehicleBrandOption.push({ vehicleOemName: 'All ', vehicleOemId: '' });
    }
    let initialProps = {
        ...rest,
        labelKey: 'vehicleOemName',
        primaryKey: 'vehicleOemId',
        options: vehicleBrandOption,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getVehicleBrandOptions = async () => {
            let getVehicleBrandParams = {};
            if (onlyVehicleMappedOems) {
                getVehicleBrandParams = { ...getVehicleBrandParams, onlyVehicleMappedOems }
            }
            if (onlyVehicleLoginBranchMappedOems) {
                getVehicleBrandParams = { ...getVehicleBrandParams, onlyVehicleLoginBranchMappedOems }
            }
            const response = await PostRequestCached('masters/getVehicleOems', getVehicleBrandParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption)
                    newOptions.push({ vehicleOemName: 'All', vehicleOemId: "" });

                if (response.data.vehicleOems.length > 0) {
                    newOptions = newOptions.concat(response.data.vehicleOems);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((ur) => selectedValues.indexOf(ur.vehicleOemId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getVehicleBrandOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default VehicleBrandAutoComplete;